<template>
  <div class="dialog-container">
    <el-row :gutter="18">
      <el-col :span="24">
        <h2>Print W-2's for Estimate</h2>
        <p>
          Estimate the client's tax refund with the generated W-2s.
          Print W-2s for estimate purposes only. <strong>(In-office use only, do not give to client)</strong>
        </p>
        <w2-pdf-button size="large" type="primary">View W-2s</w2-pdf-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import W2PdfButton from '@/components/PDFButton/W2';

export default {
  name: 'eb-print-w2',
  components: {
    W2PdfButton,
  },
  data() {
    return {
      pdfDialog: {
        visible: false,
      },
    };
  },
};
</script>
